import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsTableRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTableCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-slots-win-table',
  props: {
    showHeader: { type: Boolean },
    rowOneText: {},
    rowOneImage: {},
    rowTwoText: {},
    rowTwoImage: {},
    rowThreeText: {},
    rowThreeImage: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsTable, { theme: "dark" }, {
    default: _withCtx(() => [
      (_ctx.showHeader)
        ? (_openBlock(), _createBlock(DsTableRow, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(DsTableCell, { type: "th" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Kombinace")
                ])),
                _: 1,
                __: [0]
              }),
              _createVNode(DsTableCell, { type: "th" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Výhra")
                ])),
                _: 1,
                __: [1]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(DsTableRow, null, {
        default: _withCtx(() => [
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createVNode(WebpImage, {
                src: _ctx.rowOneImage,
                alt: "",
                "css-class": "bonusomat-win-table__table-img"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.rowOneText), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(DsTableRow, null, {
        default: _withCtx(() => [
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createVNode(WebpImage, {
                src: _ctx.rowTwoImage,
                alt: "",
                "css-class": "bonusomat-win-table__table-img"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.rowTwoText), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(DsTableRow, null, {
        default: _withCtx(() => [
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createVNode(WebpImage, {
                src: _ctx.rowThreeImage,
                alt: "",
                "css-class": "bonusomat-win-table__table-img"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.rowThreeText), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})